/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { useSelector } from "react-redux";
import React from 'react';
import Audio from "./Audio";

const AudioContainer = () => {
    const socketId = useSelector((state) => state.user.data.socketId)
    const localStream = useSelector((state) => state.room.localStream);
    const remoteStreams = useSelector((state) => state.room.remoteStreams);

    return <>
        <Audio stream={localStream} id={socketId} isLocalStream />
        {remoteStreams.map((stream) => {
            return <Audio key={stream.id} stream={stream} id={stream.connUserSocketId} isLocalStream={false}/>
        })}
    </>;
}

export default AudioContainer;
